import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecureStorageService } from '../core/services/secure-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private secureStorage: SecureStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean {
    // On server (SSR), allow navigation — the client will re-check after hydration
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    const authToken = this.secureStorage.getItem('authToken');
    if (authToken) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
